import React from 'react';
import { Link } from 'react-router-dom';
import { FaHandshake, FaUsers, FaDollarSign, FaHeadset, FaArrowRight } from 'react-icons/fa';

const PartnerWithUs = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-sans">
            {/* Navigation */}
            <nav className="bg-white shadow-sm py-4 sticky top-0 z-50">
                <div className="container mx-auto px-6 flex justify-between items-center">
                    <Link to="/" className="flex items-center gap-2">
                        <FaHandshake className="text-3xl text-rose-600" />
                        <span className="text-2xl font-black tracking-tight text-gray-900">
                            <span className="text-rose-600">BrokerNetwork</span>
                        </span>
                    </Link>
                    <div className="flex items-center gap-6">
                        <Link to="/" className="text-gray-600 hover:text-rose-600 font-medium">Home</Link>
                        <Link to="/broker-register" className="bg-rose-600 text-white px-6 py-3 rounded-xl font-bold hover:bg-rose-700 transition">
                            Become a Partner
                        </Link>
                    </div>
                </div>
            </nav>

            {/* Hero Section */}
            <section className="bg-gradient-to-br from-rose-900 via-gray-900 to-rose-900 text-white py-20">
                <div className="container mx-auto px-6 text-center">
                    <h1 className="text-5xl md:text-6xl font-bold mb-6">
                        Partner With Us
                    </h1>
                    <h2 className="text-3xl md:text-4xl font-bold mb-6">
                        Become a Broker Partner & Grow Your Business
                    </h2>
                    <p className="text-xl md:text-2xl text-gray-200 max-w-4xl mx-auto mb-10">
                        Join India's fastest growing matrimony network. Access our premium database, get dedicated support, 
                        and earn attractive commissions on every successful match.
                    </p>
                    <Link
                        to="/broker-register"
                        className="inline-flex items-center gap-3 bg-white text-rose-600 px-10 py-5 rounded-xl text-xl font-bold hover:bg-gray-100 transition shadow-lg"
                    >
                        Join Now as a Broker <FaArrowRight className="text-2xl" />
                    </Link>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto">

                        {/* Benefit 1 */}
                        <div className="text-center group">
                            <div className="inline-flex items-center justify-center w-24 h-24 bg-rose-100 rounded-full mb-6 group-hover:bg-rose-600 transition">
                                <FaUsers className="text-4xl text-rose-600 group-hover:text-white transition" />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">Access Premium Profiles</h3>
                            <p className="text-lg text-gray-600">
                                Get exclusive access to verified high-intent profiles from across India to help your clients find the perfect match faster.
                            </p>
                        </div>

                        {/* Benefit 2 */}
                        <div className="text-center group">
                            <div className="inline-flex items-center justify-center w-24 h-24 bg-rose-100 rounded-full mb-6 group-hover:bg-rose-600 transition">
                                <FaDollarSign className="text-4xl text-rose-600 group-hover:text-white transition" />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">High Commission Rates</h3>
                            <p className="text-lg text-gray-600">
                                Earn up to <span className="font-bold text-rose-600">40% commission</span> on every premium membership sold through your network.
                            </p>
                        </div>

                        {/* Benefit 3 */}
                        <div className="text-center group">
                            <div className="inline-flex items-center justify-center w-24 h-24 bg-rose-100 rounded-full mb-6 group-hover:bg-rose-600 transition">
                                <FaHeadset className="text-4xl text-rose-600 group-hover:text-white transition" />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">Dedicated Support</h3>
                            <p className="text-lg text-gray-600">
                                24/7 priority support team to assist you in closing deals faster and resolving queries instantly.
                            </p>
                        </div>

                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-20 bg-rose-600 text-white">
                <div className="container mx-auto px-6 text-center">
                    <h2 className="text-4xl font-bold mb-6">Ready to Grow Your Brokerage Business?</h2>
                    <p className="text-xl mb-10 max-w-3xl mx-auto">
                        Join thousands of successful brokers who are already earning more with ST BrokerNetwork.
                    </p>
                    <Link
                        to="/broker-register"
                        className="inline-flex items-center gap-3 bg-white text-rose-600 px-12 py-6 rounded-xl text-2xl font-bold hover:bg-gray-100 transition shadow-xl"
                    >
                        Become a Partner Today <FaHandshake className="text-3xl" />
                    </Link>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-gray-900 text-gray-400 py-10">
                <div className="container mx-auto px-6 text-center">
                    <p>&copy; 2025 ST BrokerNetwork. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default PartnerWithUs;